








































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";

import {
  PossibleExpense,
  TransactionToRemove,
  ExpenseEligibility,
  ExpenseCategory
} from "@/shared/types";

import Pill from "@/shared/components/ui/Pill.vue";
import Button from "@/shared/components/ui/Button.vue";
import EditExpenseForm from "@/shared/components/expenseV2/EditExpenseForm.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import ExpenseEligibilitySelector from "./ExpenseEligibilitySelector.vue";
import { expenseCategoryIcon } from "@/shared/awesomeIconMapper";
import { useExpenseV2Store } from "@/employee/store/expenseV2";

@Component({
  components: {
    Pill,
    Button,
    CurrencyAmount,
    ExpenseEligibilitySelector,
    EditExpenseForm
  }
})
export default class ExpenseRow extends Vue {
  expenseCategoryIcon = expenseCategoryIcon;


  expenseStore = useExpenseV2Store();

  @Prop()
  transaction: any; // PossibleExpense

  @Prop()
  expenseType: number;

  @Prop()
  onReimburseToggle: () => void;

  @Prop()
  onCheck: (id: string) => void;

  isToggled: boolean;

  @Prop()
  selected: boolean;

  @Prop()
  processingEligibility: ExpenseEligibility;

  isOpen = false;
  editExpenseSource = "confirmNew";
  isChecked = false;

  expenseOrTransaction (transactionFn: (PossibleExpense) => any, expenseFn: (Expense) => any) {
    if (this.transaction.expense) {
      return expenseFn(this.transaction.expense);
    }
    return transactionFn(this.transaction);
  }

  get expenseCategory (): ExpenseCategory {
    return this.expenseOrTransaction(tx => tx.expenseCategory, ex => ex.expenseCategory);
  }

  get title (): string {
    return this.expenseOrTransaction(tx => tx.description, ex => ex.name);
  }

  get numberOfAttachments (): number {
    if (this.transaction.expense && this.transaction.expense.attachmentNames) {
      return this.transaction.expense.attachmentNames.length;
    }

    return 0;
  }

  get showConfirmedEligible () {
    return this.transaction.eligibilityStatus === ExpenseEligibility.Eligible;
  }

  get showConfirmedIneligible () {
    return this.transaction.eligibilityStatus === ExpenseEligibility.Ineligible
      && this.processingEligibility === ExpenseEligibility.Ineligible
      && this.selected;
  }

  get showIneligible () {
    return this.transaction.eligibilityStatus.toLowerCase() === ExpenseEligibility.Ineligible.toLowerCase();
  }

  toggleEdit (e): void {
    e.preventDefault();
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.stopTimer();
    } else {
      this.reStartTimer();
    }
  }

  onEditClose (): void {
    this.isOpen = false;
    this.reStartTimer();
  }

  emitCheck (): void {
    this.onCheck(this.transaction.transactionId);
  }

  get formattedDate (): string {
    return moment(this.transaction.transactionDate).format("MMM D, YYYY");
  }

  get absoluteEligibleAmount (): number {
    const amount = this.expenseOrTransaction(tx => tx.eligibleAmount, ex => ex.amount);
    return Math.abs(amount);
  }

  stopTimer (): void {
    if (this.transaction.eligibilityStatus !== ExpenseEligibility.None) {
      this.expenseStore.removeTransactionToDisappear(this.transaction.transactionId);
    }
  }

  reStartTimer (): void {
    if (this.transaction.eligibilityStatus !== ExpenseEligibility.None) {
      const record: TransactionToRemove = {
        transactionId: this.transaction.transactionId,
        timerId: null,
        transactionType: this.expenseType
      };
      this.expenseStore.removeTransaction(record);
      this.expenseStore.removeTransactionToDisappear(record.transactionId);
      this.expenseStore.addTransactionToDisappear(record);
    }
  }
}

